/**
 * Flutter WebView Communication Bridge
 *
 * This utility provides communication between the web app and Flutter WebView.
 * It handles notifications for login/logout events and end user data.
 */

/**
 * Check if the app is running inside a Flutter WebView
 * @returns {boolean} True if FlutterChannel is available
 */
export const isInFlutterWebView = () => {
    return typeof window !== 'undefined' && !!window.FlutterChannel;
};

/**
 * Send a message to Flutter WebView
 * @param {string} message - The message to send to Flutter
 * @returns {boolean} True if message was sent successfully
 */
export const sendMessageToFlutter = (message) => {
    try {
        if (isInFlutterWebView()) {
            window.FlutterChannel.postMessage(message);
            console.log('[Flutter Bridge] Message sent:', message);
            return true;
        }
        return false;
    } catch (error) {
        console.error('[Flutter Bridge] Error sending message:', error);
        return false;
    }
};

/**
 * Notify Flutter when user logs in
 * @param {Object} endUser - The end user object (optional)
 */
export const notifyFlutterUserLoggedIn = (endUser = null) => {
    sendMessageToFlutter('userLoggedIn');

    // Also post message to parent window (for iframe support)
    try {
        window.top.postMessage({
            type: 'endUser',
            data: endUser
        }, '*');
    } catch (e) {
        console.warn('[Flutter Bridge] Failed to post message to parent window:', e);
    }
};

/**
 * Notify Flutter when user logs out
 */
export const notifyFlutterUserLoggedOut = () => {
    sendMessageToFlutter('userLoggedOut');

    // Also post message to parent window (for iframe support)
    try {
        window.top.postMessage({
            type: 'endUserLoggedOut',
            data: null
        }, '*');
    } catch (e) {
        console.warn('[Flutter Bridge] Failed to post message to parent window:', e);
    }
};

/**
 * Notify Flutter about current user status (for initial load)
 * @param {boolean} isLoggedIn - Whether user is logged in
 * @param {Object} endUser - The end user object (optional)
 */
export const notifyFlutterUserStatus = (isLoggedIn, endUser = null) => {
    if (isLoggedIn) {
        notifyFlutterUserLoggedIn(endUser);
    } else {
        notifyFlutterUserLoggedOut();
    }
};
